import { LottieIcon } from '../LottieIcon'

interface Valentines2026tagProps {
  visible?: boolean
}

export function Valentines2026tag({ visible = false }: Valentines2026tagProps) {
  return (
    <div style={{ marginLeft: '-4px' }}>
      <LottieIcon
        src="/Lottie/Valentines2026tag.json"
        width={30}
        height={30}
        autoplay={visible}
        loop={false}
      />
    </div>
  )
}
